<ng-container *ngIf='textArea && inputEnabled'>
    <div class="chatbot-input">
        <div class='textarea'>
            <textarea rows='4' #input autofocus (keyup)='validate()' (change)='validate()'
                      [placeholder]='placeholder || content.inputPlaceholder'></textarea>
            <button type="button" (click)='onSubmit()' [innerHTML]='buttonText || content.sendButtonText' [disabled]='!valid'></button>
        </div>
    </div>
</ng-container>
<ng-container *ngIf='!textArea || !inputEnabled'>
    <div class="chatbot-input" *ngIf='visibleSuggestions && visibleSuggestions.length > 0'>
        <div class='suggestions-wrapper'>
            <div class='suggestions'>
                <span class='suggestion' *ngFor='let suggestion of visibleSuggestions'
                      (click)='selectSuggestion(suggestion)' (touchstart)='selectSuggestion(suggestion, $event)'>
                    <strong>{{ suggestion[0] }}</strong>{{ suggestion[1] }}
                </span>
            </div>
        </div>
    </div>
    <div class="chatbot-input" *ngIf='inputEnabled'>
        <div class='input' [class.invalid]='!valid'>
            <input [type]='inputKind' #input (keyup)='validate() && ($event.keyCode == 13) && onSubmit()' (change)='validate()'
                   [attr.min]='inputMin' [attr.max]='inputMax' [attr.step]='inputStep'
                   [disabled]='!inputEnabled' [placeholder]='placeholder || content.inputPlaceholder'
                   autofocus />
            <button type="button" [disabled]='!valid' (click)='onSubmit()' [innerHTML]='buttonText || content.sendButtonText' aria-label='SEND'></button>
        </div>
    </div>
</ng-container>
